import React, { useState, useContext, useEffect } from "react";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  Grid,
  Typography,
  Button,
  createTheme,
  ThemeProvider,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import { ApptContext, InitialApptObj, Provider } from "../../../../../../store";
import useStyles from "../../../../../../css/styles_PE";
import {
  GetFacilityProviders,
  GetProviderSlotsByDate,
} from "../../../../../../api/PE_API";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { Autocomplete } from "@mui/lab";
import { InsertPPLogs } from "../../../../../../api";

// Update log
// FB  6192   02/06/2023  DK  Telederm by date workflow
// FB  7882   12/26/2023  SK  Book Appointment Flow isn't working in EDGE and SAFARI browser, Desktop and Smartphones - Patient Portal
// FB  8024   01/03/2024  SK  Including Recent Patient Engagement Enhancements to Patient Portal
// FB  8796   06/23/2024  KI  Auto selecting location and provider if we have only one data
// FB  9379   09/04/2024  KI  Appointment is not showing when default facility is selected in portal
export default function DateComponent_Tele(props: any) {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
      action: {
        selected: "#8BD0DB",
        hover: "#5DBDCD",
      },
    },
  });
  const { state, dispatch } = useContext(ApptContext);
  const navigate = useNavigate();
  const styles = useStyles();
  const [providers, setProviders] = useState<Provider[]>([]);
  const [open, setOpen] = useState(false);
  const loading = open && providers.length === 0;
  const [selectedprovider, SetSelectedProvider] = useState<Provider>(
    state.Provider
  );
  const [selectedDate, setSelectedDate] = useState(state.AppointmentDate);
  const [availableSlots, setAvailableSlots] = useState<number>();
  const [isDisabled, setIsDisabled] = useState(true);
  const handleProviderChange = (event: any, value: any) => {
    if (value != null) {
      SetSelectedProvider(value as Provider);
      state.Provider = value as Provider;
      //ModifyAppointmentObject(state, dispatch);
    } else {
      SetSelectedProvider(InitialApptObj.Provider);
    }
  };
  const handleDateChange = (date: any) => {
    if (date != null && date != "Invalid Date") {
      setSelectedDate(date);
      state.AppointmentDate = date;
      state.Provider = {
        ID: 0,
        Name: "",
        Facility_n: 0,
        Bio: "",
        JobTitle: ""
      };
      //ModifyAppointmentObject(state, dispatch);
    }
  };
  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }

  const handleGoback = () => {
    InsertPPLogs(
      "Clicked on Go Back - Date Telederm",
      window.location.href,
      userName,
      ""
    );
    props.setApptFilter("");
  };
  const handleProceed = () => {
    InsertPPLogs(
      "Clicked on Show Schedule - by date",
      window.location.href,
      userName,
      ""
    );
    navigate("/user/bookappointment/date/slots");
  };
  const scrollTo = (ref: any) => {
    if (ref) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    let  appt_type_n = Number(sessionStorage.getItem("AppointmentType_N"));//FB 8024
    SetSelectedProvider(InitialApptObj.Provider);
    GetFacilityProviders(format(selectedDate, "MM-dd-yyyy"), -1, 0,appt_type_n).then(
      (data: any) => {  //FB 8796
        setProviders(data);
		//FB 8796
        if(data.length == 1){
          SetSelectedProvider(data[0]);
          state.Provider = data[0] as Provider; //FB 9379
        }
      }
    );//FB 8024
  }, [selectedDate]);

  useEffect(() => {
    let splittedDate = selectedDate.toLocaleDateString().split("/");
    let date = splittedDate[0] + "-" + splittedDate[1] + "-" + splittedDate[2];
    //FB 7882 - Begin
    let value = new Date(selectedDate);
    let formattedSelectedDate = `${(value.getMonth() + 1).toString().padStart(2, '0')}-${value.getDate().toString().padStart(2, '0')}-${value.getFullYear()}`;
    GetProviderSlotsByDate(formattedSelectedDate, 0, 0).then((data) => {
      setAvailableSlots(data.length);
    });
  }, [selectedDate]);
  //FB 7882 - End

  useEffect(() => {
    if (availableSlots != 0) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [availableSlots]);

  return (
    <div ref={scrollTo}>
      <Grid container direction="row" spacing={2}>
        <Grid
          item
          xs={12}
          direction="row"
          style={{ display: "flex", alignItems: "flex-end" }}
        >
          <Typography id="selectDate" variant="h6">
            Please select the date
          </Typography>
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={2}>
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          direction="row"
          style={{ marginTop: 15 }}
        >
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <ThemeProvider theme={theme}>
              <KeyboardDatePicker
                className={styles.datepickerroot}
                id="selectDate"
                style={{ width: "-webkit-fill-available" }}
                inputVariant="standard"
                orientation={window.innerWidth > 768 ? "landscape" : "portrait"}
                value={selectedDate}
                onChange={(date) => handleDateChange(date)}
                format="MM/dd/yyyy"
                minDate={new Date()}
                minDateMessage="Date should not be in past"
              />
            </ThemeProvider>
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <ThemeProvider theme={theme}>
            <Autocomplete
              id="providerlist"
              className={styles.dropdown_nomargin}
              value={selectedprovider}
              onChange={handleProviderChange}
              getOptionLabel={(option) =>
                option.JobTitle != "" && option.JobTitle != undefined
                  ? option.Name + " (" + option.JobTitle + ")"
                  : option.Name
              }
              options={providers}
              loading={loading}
              open={open}
              onOpen={() => {
                setOpen(true);
              }}
              onClose={() => {
                setOpen(false);
              }}
              ListboxProps={{
                style: {
                  maxHeight: 200,
                },
              }}
              classes={{
                popupIndicator: styles.autocompleteIcon,
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Provider(optional)"
                  variant="standard"
                  margin="normal"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </ThemeProvider>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={3}
        direction="row"
        style={{ display: availableSlots === 0 ? "flex" : "none" }}
      >
        <Grid item xs={12}>
          <Typography
            id="noAppointmentMessage"
            variant="h6"
            style={{ color: "red" }}
          >
            No appointments available for the selected date. Please select
            another date.
          </Typography>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={3}
        direction="row"
        alignContent="flex-end"
        justify="flex-end"
        style={{ marginTop: 25 }}
      >
        <Grid
          item
          xs={6}
          sm={4}
          md={3}
          lg={2}
          style={{
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            className={styles.navigationButton}
            onClick={handleProceed}
            disabled={isDisabled}
          >
            Show Schedule
          </Button>
        </Grid>
        <Grid item xs={6} sm={3} md={2} lg={2} className={styles.flexend_Grid}>
          <Button
            id="goBackLandingPage"
            onClick={handleGoback}
            variant="contained"
            className={styles.navigationButton}
          >
            Go Back
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
